import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_parallel_coordinates.svg';
import SVG from "react-inlinesvg";

const IconParallelCoorcinatesChart = () => (

    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />

);
export default IconParallelCoorcinatesChart;